var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',{attrs:{"include":"SearchIndex,SearchResult"}},[_c(_vm.currentTabComponent,{tag:"component",attrs:{"handleBack":_vm.onBackClick,"videoClick":_vm.onVideoClick,"videoParam":_vm.videoData,"handleSearch":_vm.onSearchKey}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }